import { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Button, IconGoogle } from "../../../../components/atoms";
import {
  FlatpickerHourGroup,
  InputGroup,
  SelectGroup,
} from "../../../../components/molecules";
import { AuthContext } from "../../../../contexts/Auth/AuthContext";
import { NotificationContext } from "../../../../contexts/NotificationCTX/NotificationContext";
import { api } from "../../../../helpers";
import { useApi } from "../../../../hooks/useApi";

const theObjectsAreTheSame = (objA: Object, objB: Object) => {
  return JSON.stringify(objA) === JSON.stringify(objB);
};

export function FormTourEdit() {
  const {
    setType,
    setShow,
    setText: setTextAlert,
  } = useContext(NotificationContext);

  const { passeioID } = useParams();
  const { getPasseio } = useApi();
  const jaConsultouRef = useRef(false);

  const { applicationData } = useContext(AuthContext);

  const [campoObrigatorioHorario, setcampoObrigatorioHorario] =
    useState<boolean>(false);
  const [campoObrigatorioLotacao, setcampoObrigatorioLotacao] =
    useState<boolean>(false);
  const [campoObrigatorioFilial, setcampoObrigatorioFilial] =
    useState<boolean>(false);
  const [campoObrigatorioRota, setcampoObrigatorioRota] =
    useState<boolean>(false);
  const [campoObrigatorioCrianca, setcampoObrigatorioCrianca] =
    useState<boolean>(false);
  const [campoObrigatorioPreco, setcampoObrigatorioPreco] =
    useState<boolean>(false);
  const [campoObrigatorioBarco, setcampoObrigatorioBarco] =
    useState<boolean>(false);
  const [campoObrigatorioDuracao, setcampoObrigatorioDuracao] =
    useState<boolean>(false);

  const [passeio, setPasseio] = useState<Passeio>({
    codigo: 0,
    horario: new Date(),
    lotacao: 0,
    bagagem: 0,
    filial: 0,
    rota: "",
    recolhido: 0,
    crianca: 0,
    liberado: 0,
    recepcao: 0,
    preco: 0,
    barco: 0,
    origem: 0,
    destino: 0,
    duracao: 0,
    nomefilial: "",
    txagerba: 0,
    txembarque1: 0,
    nomeorigem: "",
    nomedestino: "",
    barconome: "",
    disponivel: 0,
    conexao: 0,
    precoconexao: 0,
    txagerbaconexao: 0,
    txembarqueconexao: 0,
  });

  const gravar = async () => {
    let useredit = applicationData.funcionario;
    const response = await api.post("/api/passeio/editar", {
      vcodigo: passeio.codigo,
      vfilial: passeio.filial,
      vhorario: passeio.horario,
      vpreco: passeio.preco,
      vlotacao: passeio.lotacao,
      vcrianca: passeio.crianca,
      vbagagem: passeio.bagagem,
      vrecolhido: passeio.recolhido,
      vliberado: passeio.liberado,
      vorigem: passeio.origem,
      vdestino: passeio.destino,
      vduracao: passeio.duracao,
      vbarco: passeio.barco,
      vrota: passeio.rota,
      useredit,
    });
    if (response.status === 200) {
      setType("success");
      setTextAlert(response.statusText);
      setShow(true);
    }
  };

  useEffect(() => {
    (async () => {
      if (!jaConsultouRef.current && passeioID) {
        jaConsultouRef.current = true;
        const passeioInfo = await getPasseio(passeioID);
        if (passeioInfo) {
          setPasseio(passeioInfo);
        }
      }
    })();
  }, []);
  return (
    <div>
      <h2>Editar Passeio</h2>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <FlatpickerHourGroup
            label="Horário"
            messageError={campoObrigatorioHorario ? "Campo obrigatório!" : ""}
            value={passeio.horario}
            id="horario"
            readOnly={true}
            onChange={([date]) => {
              if (String(date) !== "undefined") {
                setPasseio((current: any) => {
                  return { ...current, horario: date };
                });
                setcampoObrigatorioHorario(false);
              } else {
                setcampoObrigatorioHorario(true);
              }
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="Preço"
            messageError={campoObrigatorioPreco ? "Campo obrigatório!" : ""}
            id="preco"
            type="number"
            value={passeio.preco}
            autoComplete="off"
            onChange={(e) => {
              if (
                Number(e.target.value) <= 1000 &&
                Number(e.target.value) >= 0
              ) {
                setPasseio({ ...passeio, preco: Number(e.target.value) });
                setcampoObrigatorioPreco(false);
              }
              if (e.target.value === "") setcampoObrigatorioPreco(true);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={String(passeio.filial)}
            id="filial"
            messageError={campoObrigatorioFilial ? "Campo obrigatório!" : ""}
            label="Filial"
            options={applicationData.filiais.map((filial: Filial) => ({
              text: filial.nome,
              value: filial.codigo,
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 10 && Number(e.target.value) >= 0) {
                setPasseio({ ...passeio, filial: Number(e.target.value) });
                setcampoObrigatorioFilial(false);
              }
              if (e.target.value === "") setcampoObrigatorioFilial(true);
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-2">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="Lotação"
            messageError={campoObrigatorioLotacao ? "Campo obrigatório!" : ""}
            id="lotacao"
            type="number"
            value={passeio.lotacao}
            autoComplete="off"
            onChange={(e) => {
              if (
                Number(e.target.value) <= 500 &&
                Number(e.target.value) >= 0
              ) {
                setPasseio({ ...passeio, lotacao: Number(e.target.value) });
                setcampoObrigatorioLotacao(false);
              }
              if (e.target.value === "") setcampoObrigatorioLotacao(true);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-2">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="Criança"
            messageError={campoObrigatorioCrianca ? "Campo obrigatório!" : ""}
            id="crianca"
            type="number"
            value={String(passeio.crianca)}
            autoComplete="off"
            onChange={(e) => {
              if (Number(e.target.value) <= 40 && Number(e.target.value) >= 0) {
                setPasseio({ ...passeio, crianca: Number(e.target.value) });
                setcampoObrigatorioCrianca(false);
              }
              if (e.target.value === "") setcampoObrigatorioCrianca(true);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-2">
          <InputGroup
            className="col-sm-12 col-lg-2"
            label="Duração"
            messageError={campoObrigatorioDuracao ? "Campo obrigatório!" : ""}
            id="duracao"
            type="number"
            value={String(passeio.duracao)}
            autoComplete="off"
            onChange={(e) => {
              if (Number(e.target.value) <= 5 && Number(e.target.value) >= 0) {
                setPasseio({ ...passeio, duracao: Number(e.target.value) });
                setcampoObrigatorioDuracao(false);
              }
              if (e.target.value === "") setcampoObrigatorioDuracao(true);
            }}
          />
        </div>
      </div>

      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={String(passeio.origem)}
            id="origem"
            label="Origem"
            readOnly
            options={applicationData.destinos.map((destino: Destino) => ({
              text: destino.nome,
              value: destino.codigo,
            }))}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={String(passeio.destino)}
            id="destino"
            label="Destino"
            readOnly
            options={applicationData.destinos.map((destino: Destino) => ({
              text: destino.nome,
              value: destino.codigo,
            }))}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={String(passeio.barco)}
            messageError={campoObrigatorioBarco ? "Campo obrigatório!" : ""}
            id="barco"
            label="Barco"
            options={applicationData.barcos.map((barco: Barco) => ({
              text: barco.nome,
              value: barco.codigo,
            }))}
            onChange={(e) => {
              if (Number(e.target.value) <= 20 && Number(e.target.value) >= 0) {
                setPasseio({ ...passeio, barco: Number(e.target.value) });
                setcampoObrigatorioBarco(false);
              }
              if (e.target.value === "") setcampoObrigatorioBarco(true);
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={passeio.rota}
            messageError={campoObrigatorioRota ? "Campo obrigatório!" : ""}
            id="rota"
            label="Rota"
            options={[
              { text: "CONEXÃO", value: "CONEXÃO" },
              { text: "NORMAL", value: "NORMAL" },
            ]}
            onChange={(e) => {
              if (Number(e.target.value) <= 10 && Number(e.target.value) >= 0) {
                setPasseio({ ...passeio, rota: e.target.value });
                setcampoObrigatorioRota(false);
              }
              if (e.target.value === "") setcampoObrigatorioRota(true);
            }}
          />
        </div>
      </div>

      <div className="row mt-3"></div>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-2">
          <Button
            appearance="success"
            onClick={() => {
              gravar();
            }}
          >
            Gravar<IconGoogle>save</IconGoogle>
          </Button>
        </div>
      </div>
    </div>
  );
}
